(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-menu-toggle]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const menu = document.getElementById(button.getAttribute('aria-controls'));
        if (!menu) return;
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        button.setAttribute('aria-label', expanded ? 'Open menu' : 'Close menu');
        menu.hidden = expanded;
      });
    });
    root.querySelectorAll('[data-slideshow]').forEach(slideshow => {
      if (slideshow.dataset.ready) return;
      slideshow.dataset.ready = 'true';
      const slides = [...slideshow.querySelectorAll('[data-slide]')];
      const dots = [...slideshow.querySelectorAll('[data-slide-index]')];
      let active = 0;
      function show(index) {
        active = index;
        slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === index); slide.setAttribute('aria-hidden', String(i !== index)); });
        dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === index); dot.setAttribute('aria-pressed', String(i === index)); });
      }
      dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches && slides.length > 1) {
        const timer = setInterval(() => { if (!slideshow.isConnected) { clearInterval(timer); return; } if (!document.hidden && !slideshow.matches(':hover') && !slideshow.contains(document.activeElement)) show((active + 1) % slides.length); }, 5000);
      }
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();